// extracted by mini-css-extract-plugin
export default {"tabContainer":"TabView_tabContainer__XLj4V","tab":"TabView_tab__+FQGf","activeTab":"TabView_activeTab__ZDPWE"};